import axios from 'axios';

// TODO: This is an example
class Api {
  exampleFetch = (): Promise<unknown> => axios.get('https://api.coindesk.com/v1/bpi/currentprice.json');
}

export default Api;
